// src/hooks/usePersistedState.js
//
// useState-backed value persisted to sessionStorage or localStorage.
// Reads once on mount, writes on change. Handles legacy raw-string values.

import { useState, useEffect } from 'react';

const getStorage = (kind) => (kind === 'session' ? sessionStorage : localStorage);

const readValue = (store, key, defaultValue) => {
  try {
    const raw = store.getItem(key);
    if (raw === null) return defaultValue;
    try {
      return JSON.parse(raw);
    } catch {
      // Legacy raw-string value (pre-JSON format)
      return raw;
    }
  } catch {
    return defaultValue;
  }
};

export function usePersistedState(key, defaultValue, { storage = 'local' } = {}) {
  const store = getStorage(storage);

  const [value, setValue] = useState(() => readValue(store, key, defaultValue));

  useEffect(() => {
    try {
      if (value === undefined || value === null) {
        store.removeItem(key);
      } else {
        store.setItem(key, JSON.stringify(value));
      }
    } catch {
      // Ignore quota or access errors
    }
  }, [key, value, store]);

  return [value, setValue];
}